import { render, staticRenderFns } from "./CoachTeamProgressDashboard.vue?vue&type=template&id=dca70974&scoped=true&"
import script from "./CoachTeamProgressDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoachTeamProgressDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca70974",
  null
  
)

export default component.exports